window.addEventListener('DOMContentLoaded', () => {
  const closeButton = document.querySelector('.js-flash-messages > .js-close-flash-messages')
  if (!closeButton)
    return

  closeButton.addEventListener('click', () => {
    const messageArea = closeButton.closest('.js-flash-messages')
    messageArea.style.display = 'none'
  });
})
